<mat-menu #childMenu="matMenu" class="full-width">
    <span *ngFor="let diagnosis of diagnosisList">
      <!-- Handle branch node menu items -->
      <span *ngIf="diagnosis.children && diagnosis.children.length > 0">
        <button mat-menu-item [matMenuTriggerFor]="menu.childMenu" (click)="emitSelectedDiagnosis(diagnosis)">{{diagnosis.text}}</button>
        <app-diagnosis-menu-item #menu [diagnosisList]="diagnosis.children" (selectDiagnosis)="emitSelectedDiagnosis($event)"></app-diagnosis-menu-item>
      </span>
      <!-- Handle leaf node menu items -->
      <span *ngIf="!diagnosis.children || diagnosis.children.length === 0">
        <button mat-menu-item (click)="emitSelectedDiagnosis(diagnosis)">{{diagnosis.text}}</button>
      </span>
    </span>
</mat-menu>